module.exports = __webpack_public_path__ + "img/fabulous2.73fb6e28.svg";